import { useCallback, useEffect, useRef, useState } from "react";

export function useTruncationDetection() {
  const ref = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const prevTruncatedRef = useRef(false);
  const evaluateTruncation = useCallback(() => {
    const el = ref.current;
    if (!el) {
      if (prevTruncatedRef.current !== false) {
        prevTruncatedRef.current = false;
        setIsTruncated(false);
      }
      return;
    }
    const truncated = el.scrollWidth > el.clientWidth;
    if (prevTruncatedRef.current !== truncated) {
      prevTruncatedRef.current = truncated;
      setIsTruncated(truncated);
    }
  }, []);

  useEffect(() => {
    const frameId = requestAnimationFrame(() => {
      evaluateTruncation();
    });
    return () => cancelAnimationFrame(frameId);
  }, [evaluateTruncation]);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(() => {
      evaluateTruncation();
    });
    observer.observe(el);
    if (el.parentElement) {
      observer.observe(el.parentElement);
    }
    return () => {
      observer.disconnect();
    };
  }, [evaluateTruncation]);
  return [ref, isTruncated, evaluateTruncation];
}
